import { CTAButton } from 'components/CTAButton/CTAButton';
import React from 'react';

import { cx } from '@emotion/css';
import { FAQsView } from '@modules/shared/FAQs/FAQsView';

import { AreasWeCover } from '../AreasWeCover';
import { ListOfServices } from '../ListOfServices';
import { PostCodes } from '../PostCodes';
import { EmergencyComponent } from '../shared/EmergencyComponent';
import { HeroComponent } from '../shared/HeroComponent';
import { ServiceItem } from '../shared/ServiceItem';
import { TitleAndDescComponent } from '../shared/TitleAndDescComponent';
import styles from './ApplianceRepair.module.scss';

export const ApplianceRepair = () => {
  return (
    <>
      <HeroComponent
        styles={styles}
        imageLink="/images/services/appliance-repair/appliance-repair-top.jpeg"
        imageAlt="Appliance repair service banner image"
        title="Appliance Repair"
      />
      <section className={styles.services}>
        <div className={styles.root}>
          <div className={styles.services_card_block}>
            <div className={styles.container}>
              <div className={styles.inner_section}>
                <TitleAndDescComponent
                  styles={styles}
                  title="Appliance Repair Experts in London"
                  description="From washing machine repairs to dishwashers and ovens, our London-based team is here to get your appliances running smoothly again.  Fast, professional, and hassle-free!"
                />

                <CTAButton
                  title="Book Appliance Repair Service"
                  serviceName="Appliance Repair"
                />

                <div
                  className={cx(
                    styles.wrap_section,
                    styles.service_content_container,
                  )}>
                  <TitleAndDescComponent
                    styles={styles}
                    subTitle="Appliance Repair Services"
                  />
                  <div className={styles.service_items}>
                    <ServiceItem
                      styles={styles}
                      imgSrc="/images/services/appliance-repair/appliance-repairs.jpeg"
                      imgAlt="Appliance repairs"
                      title="Appliance Repairs"
                      description="Whether it’s your washing machine, tumble dryer, oven, or dishwasher, our skilled technicians have got you covered. We diagnose and repair all sorts of appliance issues, giving you a dependable solution to get your household back on track. With our appliance repair services, you can trust that we will have your appliances up and running in no time."
                    />

                    <ServiceItem
                      styles={styles}
                      imgSrc="/images/services/appliance-repair/gas-appliance-repair.jpeg"
                      imgAlt="gas appliance repair"
                      title="Gas Appliance Repairs"
                      description="technicians handle everything from gas oven repair to gas hob servicing, ensuring your gas appliances operate safely and efficiently. If your gas appliance isn't working as it should, our team will fix it with precision and care."
                    />

                    <ServiceItem
                      styles={styles}
                      imgSrc="/images/services/appliance-repair/appliance-replacement.jpeg"
                      imgAlt="appliance replacement"
                      title="Appliance Replacement"
                      description="Sometimes repair isn’t enough, and replacement becomes the best option. We offer appliance replacement services to help you upgrade to a new, more efficient model. From removing the old unit to installing the new one, our technicians ensure a seamless transition, so you can enjoy hassle-free functionality."
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <div className={styles.root}>
        <EmergencyComponent
          title="Professional Appliance Repairman"
          styles={styles}
          para1="Broken appliances can disrupt your daily routine and leave you feeling frustrated. Our appliance repair service in London is here to save the day: faulty washing machine, a stubborn dishwasher, or an oven that just won't heat up. "
          para2="We specialise in all sorts of appliance repairs and replacements. Our expert technicians are ready to help with all your household appliance needs, ensuring everything runs smoothly and efficiently. With us, there's no need to stress—just reliable fixes when you need them."
        />
        <ListOfServices
          styles={styles}
          serrviceList={[
            { name: 'Appliance repair' },
            { name: 'Appliance supply and installation' },
            { name: 'Appliance disposal' },
            { name: 'Electric oven repair' },
            { name: 'Gas oven repair' },
            { name: 'Gas hob repair' },
            { name: 'Washing machine repair' },
            { name: 'Tumble dryer repair' },
            { name: 'Dishwasher repair' },
            { name: 'Cooker hood repair' },
            { name: 'Extractor fan repairs' },
            { name: 'Leaking appliances' },
          ]}
        />
        <AreasWeCover styles={styles} />
        <PostCodes styles={styles} mainPageUrl="/services/appliance-repair" />
        <FAQsView title="Appliance Repair FAQs" faqItems={faqItems} />
      </div>
    </>
  );
};
// {name: ""},

const faqItems = [
  {
    title: 'Is it worth repairing an old appliance, or should I replace it?',
    details: `This depends on the age and condition of the appliance. If the repair cost is more than half the price of a new appliance and it’s over 8-10 years old, replacement may be more cost-effective. Our technician can advise on the best option.`,
  },
  {
    title: 'How long does a typical appliance repair take?',
    details:
      'Most repairs can be completed within 1 to 2 hours, depending on the complexity of the issue. If replacement parts are needed, the repair may take longer.',
  },
  {
    title: 'Can I attempt to repair my appliance myself?',
    details: `DIY repairs are possible for simple issues, but it’s often safer and more effective to have a qualified technician handle the repair, especially for electrical or complex mechanical problems. DIY attempts can sometimes void warranties or lead to further damage.`,
  },
  {
    title: 'Do you offer a warranty on appliance repairs?',
    details: `We provide a 12 month guarantee on labour carried out by a Qeeper tradesperson, in respect of faulty workmanship only.`,
  },
];
